import { useEffect } from "react";
import { Part } from "../../arrangement/Part";
import { Aufbau } from "../../arrangement/Aufbau";
import { v3 } from "oc-threejs/short3";

export function useKeyDownHandler(
  selected: Part | Aufbau,
  aufbauCopyBuffer: Aufbau,
  setAufbauCopyBuffer: (a: Aufbau) => void,
  setSelected: (a: (Part | Aufbau)[]) => void,
  dirty: () => void
) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const CTRL_OR_CMD = event.ctrlKey || event.metaKey;
      if ((event.target as HTMLElement).tagName === "INPUT") {
        return;
      }
      const getObjectKeys = () =>
        APP.arrangement.selectedObjects.map((o) => o.meta?.Key).filter((k) => k != null);
      const removeSelected = () => {
        APP.arrangement.removeSelectedObjects();
        APP.logUserAction({ action: "removeKey", objects: getObjectKeys() });
      };
      const copySelected = () => {
        setAufbauCopyBuffer(APP.arrangement.aufbauten.find((a) => a === selected));
        APP.logUserAction({ action: "copyKey", objects: getObjectKeys() });
      };
      const pasteSelected = () => {
        const aufbau = aufbauCopyBuffer.clone();
        aufbau.position.add(v3(1, 0, 1));
        APP.arrangement.aufbauten.push(aufbau);
        setAufbauCopyBuffer(aufbau);
        APP.logUserAction({ action: "pasteKey", objects: aufbau });
      };
      if (CTRL_OR_CMD && event.key === "z") {
        APP.undoHandler.undo();
        dirty();
      } else if (CTRL_OR_CMD && event.key === "y") {
        APP.undoHandler.redo();
        dirty();
      } else if (CTRL_OR_CMD && event.key === "c") {
        copySelected();
        dirty();
      } else if (CTRL_OR_CMD && event.key === "x") {
        copySelected();
        removeSelected();
        dirty();
      } else if (CTRL_OR_CMD && event.key === "v") {
        if (aufbauCopyBuffer) {
          pasteSelected();
          dirty();
        }
      } else if (CTRL_OR_CMD && event.key === "a") {
        event.preventDefault();
        setSelected([...APP.arrangement.getElemente(), ...APP.arrangement.aufbauten]);
      } else if (event.key === "Delete") {
        removeSelected();
        dirty();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selected, aufbauCopyBuffer]);
}
